package com.cybersoftsolution.cybersoftsolutionweb.api

import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.DeleteRequest
import com.cybersoftsolution.cybersoftsolutionweb.models.Page
import com.cybersoftsolution.cybersoftsolutionweb.models.Post
import com.cybersoftsolution.cybersoftsolutionweb.models.SimplePost
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.UPSERT_POST_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.DELETE_POSTS_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.GET_POST_BY_ID_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.GET_SIMPLE_POSTS_ROUTE
import com.cybersoftsolution.futures.base.models.Response
import com.varabyte.kobweb.browser.api
import kotlinx.browser.window
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json


suspend fun upsertPost(post: Post): Post? {
    return try {
        val request = window.api.tryPost(
            apiPath = UPSERT_POST_ROUTE,
            body = Json.encodeToString(
                post
            ).encodeToByteArray()
        )

        request?.let {
            Json.decodeFromString<Post?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("logIn Error: ${e.message}")
        null
    }

}



suspend fun getPost(text: String?, category: Category?, limit: Int?, requestPage: Int?): Response<Page<SimplePost>>? {

    val params : MutableMap<String, Any?> =
        mutableMapOf(
            Pair("text", text),
            Pair("category", category?.name),
            Pair("limit", limit),
            Pair("requestPage", requestPage),
        )

    return try {
        val request = window.api.tryGet(
            apiPath = GET_SIMPLE_POSTS_ROUTE + params.buildParams(),
        )

        request?.let {
            Json.decodeFromString<Response<Page<SimplePost>>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("getPost Error: ${e.message}")
        null
    }

}

suspend fun getPostById(id: String?): Response<Post>? {

    val params : MutableMap<String, Any?> =
        mutableMapOf(
            Pair("id", id),
        )

    return try {
        val request = window.api.tryGet(
            apiPath = GET_POST_BY_ID_ROUTE + params.buildParams(),
        )

        request?.let {
            Json.decodeFromString<Response<Post>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("getPostById Error: ${e.message}")
        null
    }

}

suspend fun deletePosts(deleteRequest: DeleteRequest): Response<Boolean>? {

    return try {
        val request = window.api.tryPost(
            apiPath = DELETE_POSTS_ROUTE,
            body = Json.encodeToString(
                deleteRequest
            ).encodeToByteArray()
        )

        request?.let {
            Json.decodeFromString<Response<Boolean>?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("deletePosts Error: ${e.message}")
        null
    }

}